import { render, staticRenderFns } from "./Contacto.vue?vue&type=template&id=e5909880"
import script from "./Contacto.vue?vue&type=script&lang=js"
export * from "./Contacto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports